import { apiResourceUrl, isNotNull } from "@ploy-lib/core";
import { BaseResource } from "./BaseResource";
const mapImageUrlToResource = (fileUrl) => {
    const [filename, type] = fileUrl.split("/").reverse();
    return {
        fileUrl,
        filename,
        type
    };
};
class ImageResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.filename = "";
        this.file = null;
        this.fileUrl = "";
    }
    pk() {
        return this.fileUrl;
    }
    static upload() {
        const listEndpoint = this.list();
        const endpoint = this.create().extend({
            schema: listEndpoint.schema,
            url: (params) => this.listUrl(params),
            method: "PUT"
        });
        return endpoint.extend({
            fetch: async (params, body = []) => {
                const formdata = new FormData();
                for (const [i, file] of body.filter(isNotNull).entries()) {
                    formdata.append(`images[${i}]`, file, file.name);
                }
                await endpoint.fetch(params, formdata);
                return await listEndpoint.fetch(params);
            }
        });
    }
    static async fetch(input, init) {
        // perform actual network request getting back json
        const jsonResponse = await super.fetch(input, init);
        if (jsonResponse && typeof jsonResponse.map === "function") {
            return jsonResponse.map(mapImageUrlToResource);
        }
        if (typeof jsonResponse === "string") {
            return mapImageUrlToResource(jsonResponse);
        }
        return mapImageUrlToResource(typeof input === "string" ? input : input.url);
    }
}
ImageResource.urlRoot = apiResourceUrl("styles");
ImageResource.urlTemplates = [
    `${ImageResource.urlRoot}/{id}/images/{type}`,
    `${ImageResource.urlRoot}/{id}/images`
];
export { ImageResource };
//# sourceMappingURL=ImageResource.js.map